module.exports = __webpack_public_path__ + "static/media/iiwk.8ae41e70.png";